import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/lib/movieData";

const friendLinks = ["光影资料馆", "城市放映室", "影迷手记", "亚洲电影观察", "银幕之外"];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center font-heading text-xl">
                秋
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-xl text-background-50">秋霞电影</span>
                <span className="mt-1 text-[10px] tracking-[0.28em] text-primary-200 uppercase">
                  {siteInfo.en}
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-primary-100/80">
              以资讯与片单为核心，记录每一部值得被看见的电影。站内内容为前端演示，不含真实播放与下载资源。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                className="inline-flex items-center gap-2 text-sm text-primary-100 hover:text-accent-300 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                {siteInfo.email}
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              <Link to="/category/action">电影分类</Link>
            </h4>
            <ul className="grid grid-cols-2 gap-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-sm text-primary-100/75 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {category.type}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">站点导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-primary-100/75 hover:text-accent-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-primary-100/75 hover:text-accent-300 transition-colors">
                  搜索结果
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-primary-100/75 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about#feedback"
                  className="text-sm text-primary-100/75 hover:text-accent-300 transition-colors"
                >
                  意见反馈
                </Link>
              </li>
            </ul>
            <h4 className="text-sm font-medium text-background-50 mt-7 mb-4">友情链接</h4>
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {friendLinks.map((link) => (
                <span key={link} className="text-xs text-primary-100/50">
                  {link}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-100/50">
            © {new Date().getFullYear()} 秋霞电影 · 影视内容聚合平台 · 演示站点
          </p>
          <p className="text-xs text-primary-100/50">
            站内图文为演示资料，不提供在线播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}